let scrollTopPrev = window.pageYOffset || document.documentElement.scrollTop;

function stickyHeaderGroups() {
  const stickyHeaderGroup = document.querySelector('.sticky-header-group');

  const isMenuDrawerClosed = (!document.querySelector('header-drawer > details[open]')) ? true : false;
  const isSearchClosed = (!document.querySelector('.header__search > details[open]')) ? true : false;
  
  if (stickyHeaderGroup && isMenuDrawerClosed && isSearchClosed) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollTopCurrent = window.pageYOffset || document.documentElement.scrollTop;
    
    const stickyHeaderGroupHeight = stickyHeaderGroup.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${stickyHeaderGroupHeight}px`);

    if (scrollTop > stickyHeaderGroupHeight) {
      // stickyHeaderGroup.classList.add('sticky-header-group-sticky', 'sticky-header-group-visible');

      if (scrollTopPrev > scrollTopCurrent) {
        // stickyHeaderGroup.classList.add('animate');
        // stickyHeaderGroup.classList.add('sticky-header-group-visible');
      } else {
        // stickyHeaderGroup.classList.remove('sticky-header-group-visible');
      }
    } else {
      // stickyHeaderGroup.classList.remove('sticky-header-group-sticky', 'sticky-header-group-visible', 'animate');
    }

    scrollTopPrev = scrollTopCurrent;
  }
}

stickyHeaderGroups();
window.addEventListener('scroll', stickyHeaderGroups);